import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPut } from "../../../API/Api_Url";
import { FaEdit, FaEye } from "react-icons/fa";
import { DollarSign, MapPin, Calendar } from "lucide-react";
import { toast } from "react-toastify";
import FreelancerAddJobPostTrackerModal from "../../Modal/FreelancerAddJobPostTrackerModal";
import FreelancerUpdateJobPostTrackerModal from "../../Modal/FreelancerUpdateJobPostTrackerModal";
import FreelancerDeleteTrackerModal from "../../Modal/FreelancerDeleteTrackerModal";

function AllAssignedJobPost({ ProUserdata }) {
    const navigate = useNavigate();
    const [JobPost, setJobPost] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetAllAssignedJobPosts = async () => {
        try {
            setIsUploading(true);
            const response = await apiGet(
                `api/freelance-engineer/FreelancerGetAllAssignedPosts`
            );
            if (response?.data) {
                setJobPost(response.data);
            } else {
                setJobPost([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setJobPost([]);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        if (ProUserdata) {
            GetAllAssignedJobPosts();
        }
    }, [ProUserdata]);

    const getStatusColor = (status) => {
        switch (status) {
            case "Pending":
                return "bg-yellow-100 text-yellow-800 border-yellow-200";
            case "Accepted":
            case "Userselected":
                return "bg-green-100 text-green-800 border-green-200";
            case "Rejected":
                return "bg-red-100 text-red-800 border-red-200";
            default:
                return "bg-gray-100 text-gray-800 border-gray-200";
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const [IsLoading, setIsLoading] = useState(false);

    const FreelancerGenerateAndAcceptAgreement = async (id) => {
        try {
            setIsLoading(true);
            const payload = {};

            const response = await apiPut(
                `api/freelance-engineer/FreelancerGenerateAndAcceptAgreement/${id}`,
                payload
            );

            if (response?.data) {
                toast.success(response?.message || "Bid Updated successfully!");
                GetAllAssignedJobPosts();
            } else {
                toast.error(response?.message || "Failed to submit bid");
            }
        } catch (error) {
            console.error("Error submitting bid:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const [AddTrackerModel, setAddTrackerModel] = useState(false);
    const [selectedReq, setselectedReq] = useState(null);

    const OpenJobTracker = (req) => {
        setAddTrackerModel(true)
        setselectedReq(req)
    }
    const CloseJobTracker = (req) => {
        setAddTrackerModel(false)
        setselectedReq(null)
    }

    const [selectedRequestId, setselectedRequestId] = useState(null);
    const [selectedTracker, setselectedTracker] = useState(null);

    const [UpdateTrackerModel, setUpdateTrackerModel] = useState(false);

    const OpenUpdateJobTracker = (id, tracker) => {
        setUpdateTrackerModel(true)
        setselectedTracker(tracker)
        setselectedRequestId(id)
    }
    const CloseUpdateJobTracker = (req) => {
        setUpdateTrackerModel(false)
        setselectedTracker(null)
        setselectedRequestId(null)
    }

    const [DeleteTrackerModel, setDeleteTrackerModel] = useState(false);

    const OpenDeleteJobTracker = (id, tracker) => {
        setDeleteTrackerModel(true)
        setselectedTracker(tracker)
        setselectedRequestId(id)
    }
    const CloseDeleteJobTracker = () => {
        setDeleteTrackerModel(false)
        setselectedTracker(null)
        setselectedRequestId(null)
    }




    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-gray-900">
                        All Assigned Freelancer Job Posts
                    </h1>
                    <p className="text-gray-600">
                        Manage and track your freelancer job posts
                    </p>
                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">
                            Loading assigned job posts...
                        </p>
                    </div>
                ) : JobPost?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">
                            No assigned job posts found.
                        </p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {JobPost?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6 mb-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">{req?.Title}</h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                <p className="text-gray-700 mb-3">{req?.Description}</p>
                                {req?.Skillsrequire?.length > 0 && (
                                    <p className="text-sm text-gray-600 mb-3">
                                        <span className="font-medium">Skills Required:</span>{" "}
                                        {req?.Skillsrequire.join(", ")}
                                    </p>
                                )}
                                <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                    <div className="flex items-center text-gray-700">
                                        <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                        <p>
                                            <span className="font-medium">Job Budget:</span> ₹{req?.Budget}
                                        </p>
                                    </div>
                                    <div className="flex items-center text-gray-700">
                                        <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                        <p>
                                            <span className="font-medium">Job Timeline:</span>{" "}
                                            {formatDate(req?.timeline?.startDate)} - {formatDate(req?.timeline?.endDate)}
                                        </p>
                                    </div>
                                </div>
                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City}, {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                {req?.SelectedFreelanceEngineer?.SelectedBid && (
                                    <div className="bg-gray-50 p-4 rounded-xl border mb-4">
                                        <h4 className="font-semibold text-gray-800 mb-2">My Quotation</h4>
                                        <p className="text-sm text-gray-700 mb-1">
                                            <span className="font-medium">Proposed Price:</span> ₹
                                            {req?.SelectedFreelanceEngineer?.SelectedBid?.ProposedPrice}
                                        </p>
                                        <p className="text-sm text-gray-700 mb-1">
                                            <span className="font-medium">Timeline:</span>{" "}
                                            {formatDate(req?.SelectedFreelanceEngineer?.SelectedBid?.Timeline?.startDate)} -{" "}
                                            {formatDate(req?.SelectedFreelanceEngineer?.SelectedBid?.Timeline?.endDate)}
                                        </p>
                                        <p className="text-sm text-gray-700 mb-1">
                                            <span className="font-medium">Note:</span>{" "}
                                            {req?.SelectedFreelanceEngineer?.SelectedBid?.Note}
                                        </p>
                                        <p className="text-sm text-gray-700">
                                            <span className="font-medium">Quotation Status:</span>{" "}
                                            <span
                                                className={`px-2 py-0.5 rounded-md text-xs font-medium ${req?.SelectedFreelanceEngineer?.SelectedBid?.Status === "Accepted"
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-yellow-100 text-yellow-700"
                                                    }`}
                                            >
                                                {req?.SelectedFreelanceEngineer?.SelectedBid?.Status || "-"}
                                            </span>
                                        </p>
                                    </div>
                                )}
                                {req?.PaymentFlow && (
                                    <div className="bg-gray-50 p-4 rounded-xl border mb-4">
                                        <h4 className="font-semibold text-gray-800 mb-2">Payment Flow</h4>

                                        {req?.PaymentFlow?.Milestones?.length > 0 && (
                                            <div className="space-y-2">
                                                {req?.PaymentFlow?.Milestones.map((m, index) => (
                                                    <div
                                                        key={m?._id || index}
                                                        className="flex justify-between items-center bg-white p-2 rounded-md border"
                                                    >
                                                        <div>
                                                            <p className="text-sm font-medium">{m?.Title}</p>
                                                            <p className="text-xs text-gray-500">Amount: ₹{m?.Amount}</p>
                                                            <p className="text-xs text-gray-500">Due Date: {formatDate(m?.DueDate)}</p>
                                                        </div>
                                                        <span
                                                            className={`px-2 py-0.5 rounded-md text-xs font-medium ${m?.Status === "Pending"
                                                                ? "bg-yellow-100 text-yellow-700"
                                                                : "bg-green-100 text-green-700"
                                                                }`}
                                                        >
                                                            {m?.Status}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {req?.WorkTracker?.length > 0 && (
                                    <div className="bg-gray-50 p-3 rounded-xl border mb-4">
                                        <h4 className="font-semibold text-gray-800 mb-2 text-sm">Work Tracker</h4>
                                        <div className="space-y-2">
                                            {req?.WorkTracker.map((tracker) => (
                                                <div
                                                    key={tracker?._id}
                                                    className="p-2 border rounded-md bg-white flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
                                                >
                                                    <div className="flex-1 min-w-0">
                                                        <p className="text-sm font-medium truncate mb-0.5">Title: {tracker?.Title}</p>
                                                        <p className="text-xs text-gray-700 truncate mb-0.5">Description: {tracker?.Description}</p>
                                                        <p className="text-xs text-gray-700 mb-0.5">Date: {tracker?.Date}</p>
                                                        <p className="text-xs text-gray-700 mb-0.5">
                                                            Status:{" "}
                                                            <span
                                                                className={`px-2 py-0.5 rounded-md text-xs font-medium ${tracker?.Status === "Pending"
                                                                    ? "bg-yellow-100 text-yellow-700"
                                                                    : "bg-green-100 text-green-700"
                                                                    }`}
                                                            >
                                                                {tracker?.Status}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div className="flex flex-col sm:flex-row sm:items-center gap-1">
                                                        {tracker?.Media?.FileUrl && (
                                                            <a
                                                                href={tracker?.Media?.FileUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="inline-block px-2 py-1 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                                                            >
                                                                {tracker?.Media?.FileType === "image" ? "View Image" : "View Video"}
                                                            </a>
                                                        )}
                                                        <button
                                                            onClick={() => OpenUpdateJobTracker(req?._id, tracker)}
                                                            className="px-2 py-1 text-xs bg-green-600 text-white rounded-md hover:bg-green-700 transition"
                                                        >
                                                            Update
                                                        </button>
                                                        <button
                                                            onClick={() => OpenDeleteJobTracker(req?._id, tracker)}
                                                            className="px-2 py-1 text-xs bg-red-600 text-white rounded-md hover:bg-red-700 transition"
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <div className="mt-6 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>

                                    <div className="flex items-center gap-2">
                                        <button className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition">
                                            <FaEye className="h-4 w-4" /> View Details
                                        </button>

                                        {req?.FreelanceEngineerAgreementRequest === "NotGenerated" && (
                                            <button
                                                onClick={() => FreelancerGenerateAndAcceptAgreement(req?._id)}
                                                className="flex items-center gap-1 px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                                            >
                                                <FaEdit className="h-4 w-4" />
                                                {IsLoading ? "Please Wait" : "Generate Agreement"}
                                            </button>
                                        )}

                                        {req?.FreelanceEngineerAgreementRequest === "Accepted" &&
                                            req?.UserAgreementRequest === "Accepted" && (
                                                <button
                                                    onClick={() => OpenJobTracker(req)}
                                                    className="flex items-center gap-1 px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                                                >
                                                    <FaEdit className="h-4 w-4" />
                                                    {IsLoading ? "Please Wait" : "Add Job Post Tracker"}
                                                </button>
                                            )}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                )}
            </div>
            <FreelancerAddJobPostTrackerModal
                isOpen={AddTrackerModel}
                onClose={CloseJobTracker}
                selectedReq={selectedReq}
                GetAllAssignedJobPosts={GetAllAssignedJobPosts}
            />

            <FreelancerUpdateJobPostTrackerModal
                isOpen={UpdateTrackerModel}
                onClose={CloseUpdateJobTracker}
                selectedRequestId={selectedRequestId}
                selectedTracker={selectedTracker}
                GetAllAssignedJobPosts={GetAllAssignedJobPosts}
            />
            <FreelancerDeleteTrackerModal
                isOpen={DeleteTrackerModel}
                onClose={CloseDeleteJobTracker}
                selectedRequestId={selectedRequestId}
                selectedTracker={selectedTracker}
                GetAllAssignedJobPosts={GetAllAssignedJobPosts}
            />
        </div>
    );
}

export default AllAssignedJobPost;
